<template>
  <b-card class="demo-unavailable border-0 mb-4" data-test="demo-unavailable">
    <h4 class="demo-unavailable__title">Not available in the demo practice</h4>
    <p class="text-muted mb-3">
      This part of Teamio is set up for your own practice: billing, credits and the connections to your accounts.
      Book a call and we'll walk you through it.
    </p>
    <b-button variant="primary" size="sm" :href="bookACallUrl" target="_blank" rel="noopener noreferrer">Book a call</b-button>
  </b-card>
</template>

<script>
/**
 * Demo site (Try Teamio, plan Task 6.5): shown in place of a tab's content that a demo session may not use (My Account
 * Credits / Billing, Settings Mango Voice). The tab itself stays registered — BootstrapVue 2.0 mis-advances the active
 * index when a <b-tab> comes and goes — so only what is inside it changes. Tests: cypress/node-tests/demo-hidden.test.js.
 */
import { BOOK_A_CALL_URL } from '@/utils/demo/demoSession';

export default {
  name: 'DemoUnavailable',
  data() {
    return { bookACallUrl: BOOK_A_CALL_URL };
  },
};
</script>

<style lang="scss" scoped>
.demo-unavailable__title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
